import type { MouseEvent } from "react";

import "./styles/circleButton.css";

interface CircleButtonProps {
	onClick: () => void;
	isClicked: boolean;
}

export function CircleButton({ onClick, isClicked }: CircleButtonProps) {
	function handleClick(event: MouseEvent<HTMLDivElement>) {
		event.preventDefault();
		if (!isClicked) onClick();
	}

	return (
		<div id="container-circles">
			<div id="outer-circle" onClick={handleClick} role="button" tabIndex={0}>
				<div id="inner-circle" className={isClicked ? "is-clicked" : ""} />
			</div>
		</div>
	);
}

export default CircleButton;
